import React, { useEffect, useMemo, useState } from "react";
import { fetchClientNetworkLogoBlob, listClientNetworkLogos } from "../services/networkLogo";
import {
    getNetworkBrandingPrefs,
    resolveActiveNetworkLogo,
} from "../utils/networkBranding";

const NetworkLogoBadge = ({ className = "" }) => {
    const [items, setItems] = useState([]);
    const [prefsVersion, setPrefsVersion] = useState(0);
    const [src, setSrc] = useState("");
    const [lightboxOpen, setLightboxOpen] = useState(false);

    useEffect(() => {
        let cancelled = false;
        (async () => {
            try {
                const data = await listClientNetworkLogos();
                if (cancelled) return;
                setItems(Array.isArray(data?.items) ? data.items : []);
            } catch (_) {
                if (!cancelled) setItems([]);
            }
        })();
        return () => { cancelled = true; };
    }, []);

    useEffect(() => {
        const onStorage = (e) => {
            if (e.key === "WR_CLIENT_NETWORK_BRANDING") setPrefsVersion((v) => v + 1);
        };
        const onCustom = () => setPrefsVersion((v) => v + 1);
        window.addEventListener("storage", onStorage);
        window.addEventListener("wr-network-branding-changed", onCustom);
        const timer = window.setInterval(() => setPrefsVersion((v) => v + 1), 60 * 1000);
        return () => {
            window.removeEventListener("storage", onStorage);
            window.removeEventListener("wr-network-branding-changed", onCustom);
            window.clearInterval(timer);
        };
    }, []);

    useEffect(() => {
        if (!lightboxOpen) return undefined;
        const onKey = (e) => {
            if (e.key === "Escape") setLightboxOpen(false);
        };
        window.addEventListener("keydown", onKey);
        const prevOverflow = document.body.style.overflow;
        document.body.style.overflow = "hidden";
        return () => {
            window.removeEventListener("keydown", onKey);
            document.body.style.overflow = prevOverflow;
        };
    }, [lightboxOpen]);

    const active = useMemo(() => {
        void prefsVersion;
        return resolveActiveNetworkLogo(items, getNetworkBrandingPrefs());
    }, [items, prefsVersion]);

    useEffect(() => {
        let revoked = false;
        let objectUrl = "";
        setSrc("");
        if (!active?.logo_url) return undefined;
        (async () => {
            try {
                const blob = await fetchClientNetworkLogoBlob(active.logo_url);
                if (revoked) return;
                objectUrl = URL.createObjectURL(blob);
                setSrc(objectUrl);
            } catch (_) {
                if (!revoked) setSrc("");
            }
        })();
        return () => {
            revoked = true;
            if (objectUrl) URL.revokeObjectURL(objectUrl);
        };
    }, [active?.logo_url, active?.network_id]);

    if (!src) return null;

    return (
        <>
            <button
                type="button"
                className={`network-logo-badge ${className}`.trim()}
                title={active?.network_name ? `${active.network_name} — натисніть, щоб збільшити` : "Логотип мережі"}
                aria-label="Збільшити логотип мережі"
                onClick={() => setLightboxOpen(true)}
            >
                <img src={src} alt={active?.network_name || "Логотип мережі"} />
            </button>

            {lightboxOpen ? (
                <div
                    className="network-logo-lightbox"
                    role="dialog"
                    aria-modal="true"
                    aria-label="Логотип мережі"
                    onClick={() => setLightboxOpen(false)}
                >
                    <button
                        type="button"
                        className="network-logo-lightbox__close"
                        aria-label="Закрити"
                        onClick={() => setLightboxOpen(false)}
                    >
                        ✕
                    </button>
                    <img
                        src={src}
                        alt={active?.network_name || "Логотип мережі"}
                        className="network-logo-lightbox__img"
                        onClick={(e) => e.stopPropagation()}
                    />
                    {active?.network_name ? (
                        <div className="network-logo-lightbox__caption" onClick={(e) => e.stopPropagation()}>
                            {active.network_name}
                        </div>
                    ) : null}
                </div>
            ) : null}
        </>
    );
};

export default NetworkLogoBadge;
